export const drawHints = {
  draw: {
    toolbar: {
      actions: {
        title: "Auswahl abbrechen",
        text: "Abbrechen",
      },
      finish: {
        title: "Auswahl fertigstellen",
        text: "Fertigstellen",
      },
      undo: {
        title: "Letzten Punkt löschen",
        text: "Letzten Punkt löschen",
      },
      buttons: {
        polygon: "Polygon zeichnen",
        rectangle: "Rechteck zeichnen",
        circle: "Kreis zeichnen",
        // circlemarker, marker and polyline not used, but needed to satisfy TS.
        polyline: "Draw a polyline",
        marker: "Draw a marker",
        circlemarker: "Draw a circlemarker",
      },
    },
    handlers: {
      circle: {
        tooltip: {
          start: "Klicken und Ziehen, um Kreis zu zeichnen.",
        },
        radius: "Radius",
      },
      polygon: {
        tooltip: {
          start: "Klicken, um Polygonstartpunkt zu zeichnen.",
          cont: "Klicken, um weiteren Polygonpunkt zu zeichnen.",
          end:
            "Auf den ersten Polygonpunkt klicken, um Auswahl fertigzustellen.",
        },
      },
      rectangle: {
        tooltip: {
          start: "Klicken und Ziehen, um Rechteck zu zeichnen.",
        },
      },
      simpleshape: {
        tooltip: {
          end: "Maustaste loslassen, um Auswahl fertigzustellen.",
        },
      },
      // circlemarker, marker and polyline not used, but needed to satisfy TS.
      circlemarker: {
        tooltip: {
          start: "Click map to place circle marker.",
        },
      },
      marker: {
        tooltip: {
          start: "Click map to place marker.",
        },
      },
      polyline: {
        error: "<strong>Error:</strong> shape edges cannot cross!",
        tooltip: {
          start: "Click to start drawing line.",
          cont: "Click to continue drawing line.",
          end: "Click last point to finish line.",
        },
      },
    },
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: "Änderungen speichern",
          text: "Speichern",
        },
        cancel: {
          title: "Bearbeitung abbrechen, Änderungen verwerfen",
          text: "Abbrechen",
        },
        clearAll: {
          title: "Alle Auswahlbereiche löschen",
          text: "Alle Auswahlbereiche löschen",
        },
      },
      buttons: {
        edit: "Auswahlbereiche bearbeiten",
        editDisabled: "Keine Auswahlbereiche zum Bearbeiten vorhanden",
        remove: "Auswahlbereiche löschen",
        removeDisabled: "Keine Auswahlbereiche zum Löschen vorhanden",
      },
    },
    handlers: {
      edit: {
        tooltip: {
          text:
            "Zum Bearbeiten Punkte bewegen und anschließend auf Speichern klicken.",
          subtext: "Auf Abbrechen klicken um Änderungen rückgängig zu machen.",
        },
      },
      remove: {
        tooltip: {
          text: "Zum Löschen auf Auswahlbereich klicken.",
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/leaflet_settings/index.ts